export const enum MESSAGE_TYPE {
  endSuccess = 'EndSuccess',
  endAbort = 'EndAbort',
  windowActive = 'WindowActive',
}
